import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { PageHeader, Row, Col, Input, Card } from 'antd';
import Content from '../../component/Content';
import ClusterHubList from './ClusterHubList';
import AnnualReviewReportModal from '../AnnualReviewReport/components/AnnualReviewReportModal';
import notifyUser from '../../utils/notify';

import { fetchClusterHubsForHome, openHub } from '../../actions/clusterHubs';

const { Search } = Input;

class Dashboard extends PureComponent {
  constructor(props) {
    super(props);
    this.state = { searchText: '', currentSearchText: '' };
  }

  componentDidMount() {
    const { fetchHubs, pagination } = this.props;
    const { page, limit } = pagination;
    fetchHubs(page, limit);
  }

  componentWillUnmount() {
    this.setState({
      searchText: '',
      currentSearchText: '',
    });
  }

  handlePaginationChange = (page, pageSize) => {
    const { fetchHubs } = this.props;
    const { currentSearchText } = this.state;
    fetchHubs(page, pageSize, currentSearchText);
  };

  handleChangeInSearch = e => {
    this.setState({
      searchText: e.target.value,
    });
  };

  handleSearch = () => {
    const { searchText } = this.state;
    const { fetchHubs, pagination } = this.props;
    const { limit } = pagination;
    const trimmedSearchText = searchText.trim();
    this.setState({ currentSearchText: trimmedSearchText });
    // Reset to page 1 when searching
    fetchHubs(1, limit, trimmedSearchText);
  };

  handleLogin = (clusterHubId, reason) => {
    if (!clusterHubId) {
      notifyUser('ClusterHub Id not found', 'error');
      return;
    }
    const { openHubAction } = this.props;
    openHubAction({ clusterHub: clusterHubId, reason });
  };

  render() {
    const { searchText } = this.state;
    const { clusterHubsLoading, pagination, clusterHubs } = this.props;
    return (
      <>
        <PageHeader title="Quick Find">
          <Row justify="center">
            <Col span={24}>
              <div style={{ textAlign: 'center' }}>
                <Search
                  placeholder="Find site by domain name, hub name, hub id, cluster name, cluster id or subdomain"
                  style={{ width: 800 }}
                  value={searchText}
                  onChange={this.handleChangeInSearch}
                  onSearch={this.handleSearch}
                  enterButton
                />
              </div>
            </Col>
          </Row>
        </PageHeader>
        <Content>
          <AnnualReviewReportModal />
          <Card bordered={false}>
            <ClusterHubList
              data={clusterHubs}
              handleLogin={this.handleLogin}
              loading={clusterHubsLoading}
              pagination={pagination}
              onPaginationChange={this.handlePaginationChange}
            />
          </Card>
        </Content>
      </>
    );
  }
}

const mapStateToProps = ({
  admin,
  clusterHubs: { clusterHubs, clusterHubsLoading, pagination },
}) => ({
  admin,
  clusterHubs,
  clusterHubsLoading,
  pagination,
});

const mapDispatchToProps = {
  fetchHubs: fetchClusterHubsForHome,
  openHubAction: openHub,
};

export default connect(mapStateToProps, mapDispatchToProps)(Dashboard);
